<template>
    <div class="detail">
        <div class="detail--travel">

            <b-container>

                <div v-if="loading" class="text-center">
                    <b-spinner variant="tertiary" />
                </div>
                
                <div v-if="!loading">

                    <div v-show="user_change_request_sent">
                        <request-sent />
                    </div>

                    <div class="panel detail--top" primary noradius>
                        <div class="detail--top--left">
                            <div class="title">
                                {{ travel.title }}
                            </div>
                            <div class="subtitle" v-if="travel.quote.details.occupancy">
                                <span v-if="travel.quote.details.occupancy.adults | travel.quote.details.occupancy.children.length">
                                    <span v-if="travel.quote.details.occupancy.adults">{{ travel.quote.details.occupancy.adults }} <span v-html="(travel.quote.details.occupancy.adults !== 1 ? 'Adulti' : 'Adulto')"></span></span>
                                    <span v-if="travel.quote.details.occupancy.children.length">, {{ travel.quote.details.occupancy.children.length }} <span v-html="(travel.quote.details.occupancy.children.length !== 1 ? 'Bambini' : 'Bambino')"></span></span>
                                </span>
                                -
                                <span>dal {{travel.quote.details.min_checkin}} al {{travel.quote.details.max_checkout}}</span>
                            </div>
                        </div>
                        <!--<div class="product-code" v-b-popover.hover.bottom="'tooltip'">-->
                        <div class="product-code">
                            <small>codice prodotto <b>{{ travel.productCode }}</b></small>
                        </div>
                    </div>
                    
                    <!-- qui tutti i servizi annidati tranne flight/package -->
                    <detail-overnight :travel="travel" v-if="travel.overnight_public_price > 0"/>

                    <!-- qui tutti i servizi annidati tranne flight/overnight -->
                    <detail-package :travel="travel" v-if="travel.package_public_price > 0"/>
                    
                    <!-- qui tutti i flight -->
                    <detail-flight :travel="travel" />

                    <div class="detail--resume">
                        <div class="panel heading" tertiary boxed>
                            <b-row>
                                <b-col sm="12" md="4">
                                    <div class="title">
                                        Prenota questo viaggio
                                        <br>
                                        <span v-if="travel.isBookable" class="bookable">Disponibile</span>
                                        <span v-else class="non-bookable">
                                            Non prenotabile ora. Fai una richiesta da questa pagina
                                        </span>
                                    </div>
                                </b-col>
                                <b-col sm="12" md="4">
                                    <div class="info">
                                        Questa soluzione è prenotabile fino al {{ travel.bookable_before.split(' ')[0] }} ore {{ travel.bookable_before.split(' ')[1] }}
                                    </div>
                                </b-col>
                                <b-col sm="12" md="4">
                                    <div class="info">
                                        RIchiedi una verifica delle disponibilità o richiedi modifiche qui sotto
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="panel content" boxed>
                            <b-row>
                                <b-col sm="12" md="4">
                                    <div class="detail--resume--totals">
                                        <div>
                                            <div class="detail--resume--totals--item" v-if="travel.overnight_public_price > 0">
                                                <div class="label">
                                                    Pernotti e servizi
                                                </div>
                                                <div class="price">
                                                    {{ travel.overnight_public_price }} €
                                                </div>
                                            </div>
                                            <div class="detail--resume--totals--item" v-if="travel.package_public_price > 0">
                                              <div class="label">
                                                Pacchetto e servizi
                                              </div>
                                              <div class="price">
                                                {{ travel.package_public_price }} €
                                              </div>
                                            </div>
                                            <div class="detail--resume--totals--item" v-if="travel.transport_public_price > 0">
                                                <div class="label">
                                                    Voli
                                                </div>
                                                <div class="price">
                                                    {{ travel.transport_public_price }} €
                                                </div>
                                            </div>
                                        </div>
                                        <div class="detail--resume--totals--item total">
                                            <div class="label">
                                                Totale
                                            </div>
                                            <div class="price">
                                                {{ travel.public_price }} €
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col sm="12" md="4">
                                    <div class="detail--resume--book">
                                        <div class="detail--resume--book--heading">
                                            <div>Codice prodotto</div>
                                            <div>{{ travel.productCode }}</div>
                                        </div>
                                        <div class="detail--resume--book--content">
                                            <button-with-icon
                                                variant="cta"
                                                text="Prenota questo viaggio"
                                                :icon="chevron_right"
                                                :clicked="() => {
                                                    this.$store.commit('set_travel', { travel: this.travel })
                                                    //this.$bvModal.show('info-pax-modal')
                                                    go_to_checkout()
                                                }"
                                                :disabled="!travel.isBookable"
                                            />
                                        </div>
                                    </div>                                    
                                </b-col>
                                <b-col sm="12" md="4">
                                    <div class="detail--resume--ask">
                                        <div class="detail--resume--ask--heading">
                                            <div v-html="camera"></div>
                                            <div v-html="bedding"></div>
                                            <div v-html="airplane"></div>
                                            <div v-html="buildings"></div>
                                            <div v-html="heart"></div>
                                            <div v-html="bus"></div>
                                            <div v-html="shield"></div>
                                        </div>
                                        <div class="detail--resume--ask--content">
                                            <button-with-icon
                                                variant="tertiary"
                                                text="Richiedi altre disponibilità o altri servizi"
                                                :icon="chevron_right"
                                                :clicked="() => {
                                                    this.$bvModal.show('request-edit-modal')
                                                }"
                                            />

                                            <b-modal id="request-edit-modal" title="Richiedi altre disponibilità o altri servizi" size="lg" hide-footer>
                                                <b-container>
                                                    <div class="m-4">
                                                        <b-form-group>
                                                            <p class="mb-3">
                                                              Dicci il numero e l'età dei partecipanti, le date del tuo viaggio, le modifiche necessarie e ti invieremo una proposta dettagliata.
                                                            </p>
                                                            <b-form-textarea
                                                                ref="user_changes_request"
                                                                id="user_changes_request"
                                                                v-model="user_changes_request"
                                                                placeholder="Numero di partecipanti, età dei partecipanti, date di viaggio o chiedi la riattivazione delle possibilità di prenotare il viaggio"
                                                            ></b-form-textarea>
                                                            <br/>
                                                            <p class="mb-3">
                                                              Numero di cellulare (raccomandato)
                                                            </p>
                                                            <b-form-input
                                                                ref="request-customer-phone"
                                                                id="request-customer-phone"
                                                                v-model="phone"
                                                                type="text"
                                                                placeholder="+39 ..."
                                                                required
                                                            ></b-form-input>
                                                        </b-form-group>

                                                        <button-with-icon
                                                            variant="cta"
                                                            text="Continua"
                                                            :icon="chevron_right"
                                                            :clicked="() => {
                                                                this.send_edit_request()
                                                            }"
                                                        />
                                                    </div>
                                                </b-container>

                                            </b-modal>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>                

                </div>
            </b-container>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import DetailOvernight from '@/components/detail/detail-overnight'
    import DetailFlight from '@/components/detail/detail-flight'
    import Bwi from '@/components/atoms/button-with-icon'
    import RequestSent from '@/components/request/request-sent'
    import { parse_flight_offers_date, custom_event } from '@/utilities'
    import { details, post_request } from '@/api'
    import { chevron_right } from '@/components/svg/chevrons'
    import { bedding, airplane, buildings, heart, bus, camera, shield } from '@/components/svg/common'
    import DetailPackage from '@/components/detail/detail-package'

    export default {
        name: 'travel-detail',
        components: {
            'detail-overnight': DetailOvernight,
            'detail-flight': DetailFlight,
            'button-with-icon': Bwi,
            'request-sent': RequestSent,
            'detail-package': DetailPackage,
        },
        props:
        {
            travel_id: String,
        },
        data() {
            return {
                user_changes_request: '',
                user_change_request_sent: false,
                travel: {},
                loading: true,
                phone: '',
            }
        },
        watch: {
            travel_id: function () {
                this.get_travel_details()
            }
        },
        computed: {
        },
        created()
        {
            this.parse_flight_offers_date = parse_flight_offers_date
            this.chevron_right = chevron_right
            this.bedding = bedding
            this.airplane = airplane
            this.buildings = buildings
            this.heart = heart
            this.bus = bus
            this.camera = camera
            this.shield = shield
        },
        mounted() {
            this.get_travel_details()
        },
        methods:{
            get_travel_details()
            {
                this.loading = true
                details({ travelId: this.travel_id })
                    .then(

                        (success) => {
                            this.travel = success.data.travel
                            this.loading = false
                        },

                        (error) => {
                          (error)
                          custom_event('invalidProductCode', this.travel_id)
                        }
                    )
            },
            update_pax_and_proceed_to_checkout(pax)
            {
                if(!this.travel.quote.pax) this.travel.quote.pax = {}
                this.travel.quote.pax = pax
                this.$store.commit('set_travel', { travel: this.travel })
                this.$bvModal.hide('info-pax-modal')
                this.go_to_checkout()
            },
            go_to_checkout()
            {
                this.$store.commit('set_travel', { travel: this.travel })
                this.$router.push({ name: 'checkout' })
            },
            send_edit_request()
            {
                this.loading = true
                let _this_travel_productCode = this.travel.productCode
                window.scrollTo(0,0)
                post_request({
                    user_change_request: this.user_changes_request,
                    user_request:
                    {
                        "request-customer":
                        {
                            firstname: Vue.prototype.$config.integration.firstname,
                            lastname: Vue.prototype.$config.integration.lastname,
                            email: Vue.prototype.$config.integration.email,
                            email_confirm: Vue.prototype.$config.integration.email,
                            company: Vue.prototype.$config.integration.company,
                            availability: Vue.prototype.$config.integration.availability,
                            viewed_product_code: this.travel.productCode,
                            phone: this.phone,
                            //email_hash: "",
                        },
                    }
                })
                    .then((response) => {
                        (response)
                        this.user_change_request_sent = true
                        this.loading = false
                        custom_event('newRequest')
                        custom_event('newRequest_fromProduct', _this_travel_productCode)
                    })
            },
        },
    }
</script>

<style lang="scss">
    //vedi _detail.scss
    .detail
    {
        .request--sent
        {
            margin-bottom:4rem;
            .panel
            {
                box-shadow: none;
            }
        }

        .title .non-bookable
        {
            font-weight: 600;
        }

        .panel.heading
        {
            //display: block;
            .row > div:not(:first-child)
            {
                //display: flex;
                //align-items: center;
                padding-top:1rem;
            }
            .title
            {
                max-width: 100%;
            }
        }
    }
</style>